export const API_ENDPOINTS = Object.freeze({
  customer: '/customer',
  customerShort: '/customer-short',
  currentCustomer: '/current-customer',
  currentCustomerShort: '/current-customer-short',
  currentCustomerApplications: '/current-customer-applications',
  customerApplications: '/customer-applications',
  customers: '/customers',
  customersShortInfo: '/customers-short',
  customerAccountManager: '/customer-accountmanager',
  currentCustomerAccountManager: '/current-customer-accountmanager',
  customerAccountRepresentative: '/customer-accountrepresentantive',
  getCustomerUsers: '/customer-users',
  getCurrentCustomerUsers: '/current-customer-users',
  getCustomerUsersWithRoles: '/customer-users-roles',
  getCurrentCustomerUsersExternal: '/current-customer-users-external',
  getCustomerUsersExternal: '/customer-users-external',
  getCurrentCustomerUsersWithRoles: '/current-customer-users-roles',
  getCustomerCreationData: '/customer-creation-data',
  getOrganizationsWithCustomers: '/organizations',
  getCustomerLicenses: 'customer-licenses',
  getCurrentCustomerLicenses: 'current-customer-licenses',
  getCustomerAccountRepresentative: '/users-account-representatives',
  checkUserAssignedToCustomer: '/user-has-customer',
  getExternalIdPs: '/get-external-idps',
  changeLocalLoginStrategyBulk: '/customer-change-login-strategy-bulk',
  changeCustomerFeatureAccess: '/customer/feature-access',
  updateMFABulk: '/customer/mfa-bulk',
  dataWipe: '/customer/hierarchy-datasets-wipe',
  oliasoftUsers: '/oliasoft-users',
  requestExternalUser: '/external-user-request'
});

export const countries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antigua &amp; Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bosnia &amp; Herzegovina',
  'Botswana',
  'Brazil',
  'British Virgin Islands',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Canada',
  'Cambodia',
  'Cameroon',
  'Cape Verde',
  'Cayman Islands',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Congo',
  'Cook Islands',
  'Costa Rica',
  'Cote D Ivoire',
  'Croatia',
  'Cruise Ship',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Polynesia',
  'French West Indies',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kuwait',
  'Kyrgyz Republic',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macau',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Namibia',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Norway',
  'Oman',
  'Pakistan',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Pierre &amp; Miquelon',
  'Samoa',
  'San Marino',
  'Satellite',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'South Africa',
  'South Korea',
  'Spain',
  'Sri Lanka',
  'St Kitts &amp; Nevis',
  'St Lucia',
  'St Vincent',
  'St. Lucia',
  'Sudan',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  "Timor L'Este",
  'Togo',
  'Tonga',
  'Trinidad &amp; Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks &amp; Caicos',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'Uruguay',
  'USA',
  'Uzbekistan',
  'Venezuela',
  'Vietnam',
  'Virgin Islands (US)',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];
export const CONTRACT_TYPE = Object.freeze({
  FREE_TRIAL: 'FREE TRIAL',
  CUSTOMER: 'CUSTOMER',
  PILOT: 'PILOT',
  INTERNAL: 'INTERNAL',
});

export const DELETE_TYPES = Object.freeze({
  SOFT: 'soft',
  HARD: 'hard',
});

export const COMPANY_CREATION_MODES = Object.freeze({
  FULL: 'full',
  TRIAL: 'trial',
});
